import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import chunk from 'lodash/chunk'
import throttle from 'lodash/throttle'

import PositionsTable from './table'
import Pagination from 'common/Pagination'

import { propertySort } from 'services/string'

const ROWS_PER_PAGE = 10

class Table extends React.Component {
  static propTypes = {
    positions: PropTypes.array,
    locations: PropTypes.array,
    departments: PropTypes.array,
    department: PropTypes.string,
    location: PropTypes.string,
    dispatch: PropTypes.func,
    isFetching: PropTypes.bool,
  }

  constructor (props) {
    super(props)

    this.state = {
      searchFilter: '',
      departmentFilter: props.department || '',
      locationFilter: props.location || '',
      currentPage: 1,
      sortBy: 'name',
      sortOrder: -1,
    }
  }

  componentDidMount () {
    if (!this.props.isFetching) {
      this.addResizeEvent() // add resize event if data is ready when mounted
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.department !== this.props.department) {
      this.setState({ // eslint-disable-line
        departmentFilter: this.props.department,
        sortBy: 'name',
        sortOrder: -1,
      })
    }

    if (prevProps.location !== this.props.location) {
      this.setState({ // eslint-disable-line
        locationFilter: this.props.location,
        sortBy: 'name',
        sortOrder: -1,
      })
    }

    if (!this.props.isFetching && prevProps.isFetching) {
      this.addResizeEvent() // add resize event after data is fetched if not yet available
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', throttle(this.onResize, 100))
  }

  addResizeEvent () {
    window.addEventListener('resize', throttle(this.onResize, 100))
  }

  onResize = e => {
    const smallPositionTable = document.getElementById('smallPositionTable')
    // offsetParent will return null if element is display none
    if (smallPositionTable && smallPositionTable.offsetParent && this.state.sortBy !== 'name') {
      this.setState({
        currentPage: 1,
        sortBy: 'name',
        sortOrder: -1,
      })
    }
  }

  onSearch = e => {
    const value = e.target.value
    this.setState(state => ({
      currentPage: 1,
      searchFilter: value,
    }))
  }

  onChangeDepartment = e => {
    const value = e.target.value
    this.setState(state => ({
      currentPage: 1,
      departmentFilter: value,
    }))
  }

  onChangeLocation = e => {
    const value = e.target.value
    this.setState(state => ({
      currentPage: 1,
      locationFilter: value,
    }))
  }

  onChangePage = page => {
    this.setState(() => ({
      currentPage: page,
    }))
  }

  onClickHeader = sortBy => {
    this.state.sortBy === sortBy
      ? this.setState({
        currentPage: 1,
        sortOrder: -this.state.sortOrder,
      })
      : this.setState({
        currentPage: 1,
        sortBy: sortBy,
        sortOrder: -1,
      })
  }

  propertySort = (a, b) => {
    return propertySort(a, b, this.state.sortBy, this.state.sortOrder)
  }

  getFilteredPositions = () => {
    const searchFilter = this.state.searchFilter.toLowerCase()
    const departmentFilter = this.state.departmentFilter.toLowerCase()
    const locationFilter = this.state.locationFilter.toLowerCase()

    const positions = this.props.positions || []

    const filteredPositions = positions
      .filter(pos => {
        return searchFilter
          ? pos.name.toLowerCase().includes(searchFilter)
          : true
      })
      .filter(pos => {
        return departmentFilter
          ? pos.department.toLowerCase() === departmentFilter
          : true
      })
      .filter(pos => {
        return locationFilter
          ? pos.city.toLowerCase() === locationFilter
          : true
      })

    return filteredPositions.sort(this.propertySort)
  }

  getPagedPositions = () => {
    const pos = this.getFilteredPositions()

    if (pos.length === 0) {
      return []
    }

    return chunk(pos, ROWS_PER_PAGE)[this.state.currentPage - 1]
  }

  getPageCount = () => {
    const positions = this.getFilteredPositions()
    const count = Math.ceil(positions.length / ROWS_PER_PAGE)

    return count > 0 ? count : 1
  }

  render () {
    const {
      locations,
      departments,
      positions,
      department,
      location,
      isFetching,
      ...rest
    } = this.props

    return isFetching
      ? <img src='assets/spinner-square.gif' className='db center w-20 w-20-m w-10-l' />
      : [
        <PositionsTable {...rest}
          key='table'
          id='bamboohr'
          locations={locations}
          positions={this.getPagedPositions()}
          departments={departments}
          onSearch={this.onSearch}
          onChangeDepartment={this.onChangeDepartment}
          onChangeLocation={this.onChangeLocation}
          selectedDepartment={this.state.departmentFilter}
          selectedLocation={this.state.locationFilter}
          onClickHeader={this.onClickHeader}
          sortBy={this.state.sortBy}
          sortOrder={this.state.sortOrder}
        />,
        <Pagination key='pagination'
          className='flex items-center justify-center st-mt4'
          current={this.state.currentPage}
          onChange={this.onChangePage}
          total={this.getPageCount()}
        />,
      ]
  }
}

export default connect(
  state => state.positions,
  null,
)(Table)
